import type { StreamingMessage } from "@storytell/streaming";
import type { AssetId } from "@storytell/types";
import { useWire } from "~/wire";

export const useMessageHasKnowledgeSearchAssets = () => {
  const wire = useWire();

  return (message: StreamingMessage | undefined) => {
    if (!message) return false;

    for (const o of message.operations) {
      const op = wire.stream.operation.get(o);
      if (op?.activity === "kb_search") {
        for (const blockId of op.blocks) {
          const block = wire.stream.block.get(blockId);
          if (!block) continue;

          if (block.searchResults) {
            if (block.searchResults.results.case === "assets") {
              for (const asset of block.searchResults.results.value.assets) {
                if (wire.rels.conceptsForAsset(asset.assetId as AssetId).length > 0) {
                  return true;
                }
              }
            }
          }
        }
      }
    }
    return false;
  };
};
